import React from 'react';

import {Group} from '@pb/kit-component-group';
import {StickyElement} from '@pb/kit-component-sticky-element';
import Typography from '@pb/kit-component-typography';
import {pluralize} from '@pb/kit-formatters';

import {
    profileTableHeader,
    profileTableHeaderSeparator,
    profileTableHeaderTotalCount,
} from './profile-table-header.module.styl';


type Props = {
    totalCount?: number,
    caption: string,
    entityCaption: string,
    children?: React.ReactNode,
};

export const ProfileTableHeader = ({totalCount, entityCaption, children, caption}: Props) => (
    <StickyElement findStickToElement={true}>
        <div className={profileTableHeader}>
            <header className="pdy-m">
                <Group direction="h" alignItems="center">
                    <Typography fontWeight="semi-bold" variant="heading-level-3">{caption}</Typography>
                    {totalCount ? (
                        <>
                            <span className={profileTableHeaderSeparator}/>
                            <span className={profileTableHeaderTotalCount}>
                                {pluralize(`${totalCount} ${entityCaption}[s]`, totalCount)}
                            </span>
                        </>
                    ) : null}
                </Group>
            </header>
            {children}
        </div>
    </StickyElement>
);
